import React from "react";
import Tour from "../../components/tour/Tour";
import { data } from "../../components/tour/lists/tourData06";

export default () => <Tour data={data} />;